import './ypk.css'
import psixolog from './foto/psixolog.jpg'
import ps2 from './foto/ps2.jpg'
import ps3 from './foto/ps3.jpg'
import ps4 from './foto/ps4.jpg'
import ps5 from './foto/ps5.jpg'
import { useState } from 'react'

export default function YPK() {
    const [activeImage, setActiveImage] = useState(null)
    const images = [ps2, ps3, ps4, ps5]
    return (
        <div className="ypk">
            <header className="ypk_header">
                <h1>Yosh psixologlar klubi</h1>
                <p className="ypk_sub">Ranch universitetida "Yosh psixologlar" klubi faoliyat ko‘rsatadi</p>
            </header>

            <section className="ypk_profile card">
                <div className="ypk_profile_img">
                    {/* Rasmingizni public/ypk/psixolog.jpg ga joylang yoki quyidagi src ni o'zgartiring */}
                    <img src={psixolog} alt="Psixolog rasmi" />
                </div>
                <div className="ypk_profile_info">
                    <h2>Masʼul psixolog</h2>
                    <p className="ypk_profile_name">Niyazmetova Munira Ibragimovna</p>
                    <p className="muted">Talabalar va xodimlarga psixologik yordam ko‘rsatish faoliyati yo‘lga qo‘yilgan.</p>
                    <p>
                        Telegram bot: <a href="https://t.me/ranch_psixologik_yordam_bot" target="_blank" rel="noreferrer">@ranch_psixologik_yordam_bot</a>
                    </p>
                </div>
            </section>

            <section className="ypk_section card">
                <h2>Klub haqida</h2>
                <p>
                    Yosh psixologlar klubiga psixologiyaga qiziqqan talabalar a’zo bo‘lishi mumkin. Bu yerda ular psixologiya fani bilan yaqindan tanishib, o‘z hayotlarida qo‘llash imkoniyatiga ega bo‘lishadi.
                </p>
            </section>

            {/* <section className="ypk_section card">
                <h2>Tadbirlar va loyihalar</h2>
                <p className="muted">Seminar, trening va uchrashuvlar haqida maʼlumotlar shu yerda joylanadi.</p>
                <div className="grid two">
                    <div className="ph_block">
                        <h3>Seminar/trening</h3>
                        <p>Kutilayotgan tadbir tavsifi. Sana, joy va aloqa.</p>
                    </div>
                    <div className="ph_block">
                        <h3>Loyiha</h3>
                        <p>Qoʻllab-quvvatlanayotgan loyiha haqida qisqacha maʼlumot.</p>
                    </div>
                </div>
            </section> */}

            <section className="ypk_section card">
                <h2>Psixologik yordam boti</h2>
                <p>
                    Talabalar va ishchi xodimlar uchun anonim murojaat qilish mumkin bo‘lgan psixologik yordam boti yaratilgan.
                </p>
                <p>
                    Telegram: <a href="https://t.me/ranch_psixologik_yordam_bot" target="_blank" rel="noreferrer">@ranch_psixologik_yordam_bot</a>
                </p>
            </section>

            <section className="ypk_gallery card">
                <div className="gallery_header">
                    <h2>Foto galereya</h2>
                    {/* <p>Rasmlar uchun joy qoldirildi — siz qoʻshasiz</p> */}
                </div>
                <div className="grid four">
                    {images.map((src, idx) => (
                        <button
                            key={idx}
                            className="thumb"
                            onClick={() => setActiveImage(src)}
                            aria-label={`Rasm ${idx + 1} ni kattalashtirish`}
                        >
                            <img src={src} alt={`Galereya rasm ${idx + 1}`} />
                        </button>
                    ))}
                </div>
            </section>

            <section className="ypk_contacts card">
                <h2>Aloqa</h2>
                <div className="grid two">
                    <div>
                        <p><strong>Masʼul shaxs:</strong> Ranch psixologi Niyazmetova Munira Ibragimovna</p>
                        <p><strong>Telefon:</strong> ———</p>
                        <p><strong>Email:</strong> ———</p>
                    </div>
                    <div>
                        {/* <p><strong>Manzil:</strong> Urganch shahar, UTU Ranch</p> */}
                        {/* <p><strong>Ish vaqti:</strong> Du–Ju, 09:00–17:00</p> */}
                    </div>
                </div>
            </section>
            {activeImage && (
                <div className="ypk_modal" role="dialog" aria-modal="true" onClick={() => setActiveImage(null)}>
                    <div className="ypk_modal_inner" onClick={(e) => e.stopPropagation()}>
                        <button className="ypk_modal_close" onClick={() => setActiveImage(null)} aria-label="Yopish">×</button>
                        <img src={activeImage} alt="Kattalashtirilgan rasm" />
                    </div>
                </div>
            )}
        </div>
    )
}


